// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__v0f_q","alert":"SettungsInbox_alert__1wuf_"};